export default function Button(props) {
    
    const offset = props.height * 0.1;

    const borderRadius = props.borderRadius;

    const color = props.color;
    const secondaryColor = props.secondaryColor;

    const text = props.text;

    const isTapped = props.isTapped;
    const disabled = props.disabled;

    const onClick = props.onClick;

    return (
        <div className="button"
                onClick={() => onClick()}
            >
                {text}
            </div>
    )
}